import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'

export const useRecaptcha = () => {
  const { executeRecaptcha } = useGoogleReCaptcha()

  const verifyRecaptcha = async (action = 'submit') => {
    if (!executeRecaptcha) {
      console.warn('reCAPTCHA not loaded yet')
      return { success: false, error: 'reCAPTCHA not loaded' }
    }

    try {
      // Get reCAPTCHA token
      const token = await executeRecaptcha(action)

      // Verify token with Supabase Edge Function
      const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
      const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

      const response = await fetch(
        `${supabaseUrl}/functions/v1/verify-recaptcha`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'apikey': supabaseAnonKey,
            'Authorization': `Bearer ${supabaseAnonKey}`
          },
          body: JSON.stringify({ token })
        }
      )

      if (!response.ok) {
        const errorData = await response.json()
        console.error('reCAPTCHA verification error:', errorData)
        return { success: false, error: errorData.message || 'Verification failed' }
      }

      const data = await response.json()
      return data
    } catch (error) {
      console.error('reCAPTCHA error:', error)
      return { success: false, error: error.message }
    }
  }

  return { verifyRecaptcha }
}
